import { Button, ButtonVariant, ButtonSize } from "shared/components";
import { Folder } from "untitledui-js-base";
import { Layout } from "providers/Layout";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { useNavigate } from "react-router-dom";
import templatesApi from "api/landlord/templates";
import { useQuery } from "@tanstack/react-query";

export const EmptyPropertyGroups = () => {
  const navigate = useNavigate();
  const { properties, Property, property } = useUnitsPropertiesDictionary();

  const { data: templates, isLoading } = useQuery({
    queryKey: ["TEMPLATES"],
    queryFn: () => templatesApi.getTemplates(1, 1).then((res) => res.items)
  });

  return (
    <Layout sectionClassName="flex flex-col gap-6 size-full items-center justify-center">
      <div className="p-[30px] rounded-full bg-primary-20">
        <Folder className="size-10 stroke-primary-500" />
      </div>
      <div className="space-y-2 text-center">
        <h3 className="font-bold text-base text-content-500">
          {Property} Groups
        </h3>
        <p className="font-medium text-sm text-content-300 w-[445px]">
          {Property} groups allow you to organize {properties} by key criteria,
          improving the efficiency of assigning templates, managing access, etc.
        </p>
      </div>
      <Button
        loading={isLoading}
        disabled={!templates || templates.length === 0}
        tooltip={
          !templates || templates.length === 0
            ? "You need at least one screening template to set up property groups"
            : undefined
        }
        tooltipPlacement="bottom"
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.LG}
        onClick={() => navigate("/property-groups/configuration")}
      >
        Setup {property} groups
      </Button>
    </Layout>
  );
};
